import type { TOC } from '@ember/component/template-only';
import { PrismCheckbox } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

import type {
  RateGroupRow,
  RateGroupSectionRow,
} from '../rate-groups-accordion';

interface TdAutomationCheckboxSignature {
  Args: {
    row: RateGroupRow | RateGroupSectionRow;
  };
}

/* aria-labelledby lists the rate group name, then the checkbox itself (read from its
   aria-label), so each row's checkbox is announced as "<rate group> Automation on". */
const TdAutomationCheckbox = <template>
  {{#unless @row.isSection}}
    <PrismCheckbox
      @checked={{@row.state.automationOn}}
      @disabled={{@row.state.isLoading}}
      @onChange={{@row.state.toggleAutomation}}
      aria-label={{t "pricing_manager.automation_on"}}
      aria-labelledby="rate-group-{{@row.rateGroupId}}-name rate-group-{{@row.rateGroupId}}-automation"
      data-test-id="rate-group-automation-checkbox"
      id="rate-group-{{@row.rateGroupId}}-automation"
    />
  {{/unless}}
</template> satisfies TOC<TdAutomationCheckboxSignature>;

export default TdAutomationCheckbox;
